"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classcat = _interopRequireDefault(require("classcat"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SVGIcon = _interopRequireDefault(require("../SVGIcon"));

var _MonthNames = _interopRequireDefault(require("./MonthNames"));

var _MonthSelector = _interopRequireDefault(require("./MonthSelector"));

var _MonthView = _interopRequireDefault(require("./MonthView"));

var _YearSelector = _interopRequireDefault(require("./YearSelector"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const nowDate = () => {
  return new Date().toISOString().split('T')[0];
};

const Header = _styledComponents.default.div.withConfig({
  displayName: "MiniCalendar__Header",
  componentId: "sc-1n62ckg-0"
})(["display:flex;justify-content:center;", "{width:48px;flex-shrink:0;}"], _SVGIcon.default);

const HeaderButton = _styledComponents.default.div.withConfig({
  displayName: "MiniCalendar__HeaderButton",
  componentId: "sc-1n62ckg-1"
})(["display:flex;align-items:center;cursor:pointer;font-weight:400;padding:16px;height:48px;", ";border:1px solid transparent;border-bottom:0;margin:0;margin-bottom:-1px;&.selected{background:#fff;border-color:#eee;position:relative;z-index:2;}&:hover:not(.selected){background:#eee;}", "{max-width:48px;}"], p => p.theme.transition, _SVGIcon.default);

const Spacing = _styledComponents.default.div.withConfig({
  displayName: "MiniCalendar__Spacing",
  componentId: "sc-1n62ckg-2"
})(["flex:1;"]);

const Selector = _styledComponents.default.div.withConfig({
  displayName: "MiniCalendar__Selector",
  componentId: "sc-1n62ckg-3"
})(["position:absolute;z-index:1;width:320px;height:240px;background:#fff;"]);

const Content = _styledComponents.default.div.withConfig({
  displayName: "MiniCalendar__Content",
  componentId: "sc-1n62ckg-4"
})(["flex:1;display:flex;"]);

class MiniCalendar extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      show: '',
      selectedDate: '',
      month: '',
      year: ''
    });

    _defineProperty(this, "selectDate", () => {
      let {
        select
      } = this.props;
      const {
        selectedDate
      } = this.state;
      select = select || nowDate();

      if (select === selectedDate) {
        return;
      }

      const [year, month] = select.split('-');
      this.setState({
        selectedDate: select,
        month: parseInt(month, 10),
        year: parseInt(year, 10)
      });
    });

    _defineProperty(this, "showSelector", name => () => {
      this.setState(prevState => ({
        show: prevState.show === name ? '' : name
      }));
    });

    _defineProperty(this, "onMonthSelect", month => {
      const {
        onMonthSelect
      } = this.props;
      this.setState({
        month,
        show: ''
      });
      onMonthSelect(month);
    });

    _defineProperty(this, "onYearSelect", year => {
      const {
        onYearSelect
      } = this.props;
      this.setState({
        year,
        show: ''
      });
      onYearSelect(year);
    });

    _defineProperty(this, "showPreviousMonth", () => {
      const {
        month,
        year
      } = this.state;

      if (month > 1) {
        this.onMonthSelect(month - 1);
      } else {
        this.onMonthSelect(12);
        this.onYearSelect(year - 1);
      }
    });

    _defineProperty(this, "showNextMonth", () => {
      const {
        month,
        year
      } = this.state;

      if (month < 12) {
        this.onMonthSelect(month + 1);
      } else {
        this.onMonthSelect(1);
        this.onYearSelect(year + 1);
      }
    });
  }

  componentDidMount() {
    this.selectDate();
  }

  componentDidUpdate() {
    this.selectDate();
  }

  render() {
    const {
      className,
      onSelect,
      headerOnly
    } = this.props;
    const {
      show,
      month,
      year,
      selectedDate
    } = this.state;

    if (!month || !year) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement(HeaderButton, {
      as: _SVGIcon.default,
      name: "chevronLeft",
      color: "555",
      onClick: this.showPreviousMonth
    }), /*#__PURE__*/_react.default.createElement(Spacing, null), /*#__PURE__*/_react.default.createElement(HeaderButton, {
      className: (0, _classcat.default)({
        selected: show === 'month'
      }),
      onClick: this.showSelector('month')
    }, _MonthNames.default[month - 1]), /*#__PURE__*/_react.default.createElement(HeaderButton, {
      className: (0, _classcat.default)({
        selected: show === 'year'
      }),
      onClick: this.showSelector('year')
    }, year), /*#__PURE__*/_react.default.createElement(Spacing, null), /*#__PURE__*/_react.default.createElement(HeaderButton, {
      as: _SVGIcon.default,
      name: "chevronRight",
      color: "555",
      onClick: this.showNextMonth
    })), /*#__PURE__*/_react.default.createElement(Content, null, (show === 'month' || show === 'year') && /*#__PURE__*/_react.default.createElement(Selector, null, show === 'month' && /*#__PURE__*/_react.default.createElement(_MonthSelector.default, {
      month: month,
      onSelect: this.onMonthSelect
    }), show === 'year' && /*#__PURE__*/_react.default.createElement(_YearSelector.default, {
      year: year,
      onSelect: this.onYearSelect
    })), !headerOnly && show === '' && /*#__PURE__*/_react.default.createElement(_MonthView.default, {
      month: month,
      year: year,
      select: selectedDate,
      onSelect: onSelect
    })));
  }

}

MiniCalendar.defaultProps = {
  onMonthSelect: () => {},
  onYearSelect: () => {}
};

var _default = (0, _styledComponents.default)(MiniCalendar).withConfig({
  displayName: "MiniCalendar",
  componentId: "sc-1n62ckg-5"
})(["display:flex;flex-direction:column;width:320px;color:#333;"]);

exports.default = _default;